import CatalogByParams from "../../ui/catalog/CatalogByParams";
import {useContext, useEffect, useState} from "react";
import {ApiRequestInterface} from "../../interfaces/catalog/ApiRequestInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

export default function Favorites() {
    const [params, setParams] = useState<ApiRequestInterface>({})
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: [{name: 'Избранное' }]})
    }, []);

    useEffect(() => {
        setParams({id: state.favorites.map(item => item.id.toString())});
    }, [state.favorites]);

    return (<>{params.id?.length && <CatalogByParams params={params} header={'Избранное'} baseUrl={'/favorites'}/>}
        {!params.id?.length && <h1 className={'text-center my-5 py-5'}>В избранном пока ничего нет</h1>}
    </>);
}